module.exports = __webpack_public_path__ + "img/ukrain.8dc69706.svg";